import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import Offers from "../../components/Company/Offer/Offers";
import CreateOfferModal from "../../components/Company/Offer/CreateOfferModal";
import { useCompanyDeals } from "../../hooks/useDeals";
import { OfferProvider } from "../../hooks/useOfferReducer";

const CompanyOffers = () => {
  const { page, setIsLoading, setIsModalOpen } = useOutletContext();
  const [currentDeal, setCurrentDeal] = useState(null);
  const [isModalOpen, setIsModalOpenLocal] = useState(false);
  const [response, setResponse] = useState(null);
  const [modalKey, setModalKey] = useState(0); // Clé pour forcer la réinitialisation

  // Fonction pour gérer l'ouverture du modal (création ou modification)
  const handleModalOpen = (deal = null) => {
    if (deal) {
      // Modification : on a un deal
      setCurrentDeal(deal);
      setIsModalOpenLocal(true);
    } else {
      // Création : pas de deal
      setCurrentDeal(null);
      setModalKey(prev => prev + 1); // Incrémenter la clé pour forcer la réinitialisation
      setIsModalOpenLocal(true);
    }
  };

  // React Query pour récupérer les offres
  const { 
    data: dealsData, 
    isLoading: dealsLoading, 
    error: dealsError,
    refetch: refetchDeals 
  } = useCompanyDeals(page?._id, false); // false = offres actives

  const deals = dealsData;

  return (
    <>
      <Offers 
        setCurrentDeal={handleModalOpen} // Passer la fonction qui gère les deux cas
        deals={deals} 
        setDeals={refetchDeals} // Utiliser refetch au lieu de setDeals
        page={page} 
        setIsModalOpen={handleModalOpen} // Passer la fonction qui gère les deux cas
        isLoading={dealsLoading}
        error={dealsError}
      />
      
      {/* OfferProvider isolé pour chaque instance du modal */}
      <OfferProvider key={modalKey}>
        <CreateOfferModal 
          isAdmin={false} 
          setCurrentDeal={setCurrentDeal} 
          currentDeal={currentDeal} 
          deals={deals} 
          setDeals={refetchDeals} // Utiliser refetch au lieu de setDeals
          page={page} 
          setIsLoading={setIsLoading} 
          setIsModalOpen={setIsModalOpenLocal} 
          isModalOpen={isModalOpen} 
          setResponse={setResponse}
        />
      </OfferProvider>
    </>
  );
};

export default CompanyOffers;